import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import Button from '../../CustomButtons/Button.js';

const PlannerFeatureCard = ({
  classes,
  iconSrc,
  iconAlt,
  title,
  description,
  buttonLabel,
  onButtonClick,
  cardBodyStyle,
  buttonColor,
}) => (
  <Card className={classes.card}>
    <CardBody className={classes.cardBody} style={cardBodyStyle}>
      <div className={classes.cardContainer}>
        <img src={iconSrc} alt={iconAlt} className={classes.cardIcon} />
        <section className={classes.menuTitle}>
          <span className={classes.cardHeader}>{title}</span>
        </section>
        <aside className={classes.menuDesc}>{description}</aside>
      </div>
      <Button className={classes.cardButton} color={buttonColor} variant="contained" round onClick={onButtonClick}>
        {buttonLabel}
      </Button>
    </CardBody>
  </Card>
);

PlannerFeatureCard.propTypes = {
  classes: PropTypes.object.isRequired,
  iconSrc: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  buttonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onButtonClick: PropTypes.func.isRequired,
  cardBodyStyle: PropTypes.object,
  buttonColor: PropTypes.string,
};

PlannerFeatureCard.defaultProps = {
  cardBodyStyle: undefined,
  buttonColor: 'primary',
};

export default PlannerFeatureCard;
